import "core-js/modules/es.array.iterator.js";
import React from 'react';
import { FixedSizeList as List } from 'react-window';
const height = 35;
export const VirtualizedMenuList = props => {
  const {
    options,
    children,
    maxHeight,
    getValue
  } = props;
  const [value] = getValue();
  const initialOffset = options.indexOf(value) * height;
  const items = children;
  return /*#__PURE__*/React.createElement(List, {
    width: '100%',
    height: maxHeight,
    itemCount: items.length,
    itemSize: height,
    initialScrollOffset: initialOffset
  }, ({
    index,
    style
  }) => /*#__PURE__*/React.createElement("div", {
    style: style
  }, items[index]));
};